import React from "react";

import { Space } from "@masterteam/mt-design-react";

import Item from "./Item";

import "./style.scss";

function UsersList({
  users = [],
  title,
  selectedUsers,
  setSelectedUsers,
  valueKey,
  nameKey,
  error
}) {
  function toggleSelectUser(user, shouldAdd) {
    let newSelectedUsers = [...selectedUsers];
    if (shouldAdd) newSelectedUsers.push(user);
    else
      newSelectedUsers = newSelectedUsers?.filter(
        e => e?.[valueKey] !== user?.[valueKey]
      );

    setSelectedUsers(newSelectedUsers);
  }

  return (
    <Space direction="vertical" className="users-groups-picker__users-list">
      <div className="list-title">{title}</div>
      <div className={`list-content ${error ? "list-content__error" : ""}`}>
        {users?.map(e => (
          <Item
            key={e?.[valueKey]}
            data={e}
            nameKey={nameKey}
            onSelectUser={toggleSelectUser}
            isSelected={Boolean(
              selectedUsers?.find(user => user?.[valueKey] === e?.[valueKey])
            )}
          />
        ))}
      </div>
    </Space>
  );
}

export default UsersList;
